/* Imports */
import React from "react"
import { ProgressBar } from "fajny-react"
import { getRandomNumber } from "js-utils-julseb"

import ComponentPage from "../../components/ComponentPage"

import commonProps from "../../data/common-props"

const ProgressBarPage = () => {
    const randomPrimary = getRandomNumber(0, 100)
    const randomSecondary = getRandomNumber(0, 100)
    const randomSuccess = getRandomNumber(0, 100)
    const randomDanger = getRandomNumber(0, 100)
    const randomWarning = getRandomNumber(0, 100)
    const randomGray = getRandomNumber(0, 100)
    const randomBlack = getRandomNumber(0, 100)
    const randomWhite = getRandomNumber(0, 100)

    const items = [
        {
            content: (
                <>
                    <ProgressBar value={randomPrimary} color="primary" />
                    <ProgressBar value={randomSecondary} color="secondary" />
                    <ProgressBar value={randomSuccess} color="success" />
                    <ProgressBar value={randomDanger} color="danger" />
                    <ProgressBar value={randomWarning} color="warning" />
                    <ProgressBar value={randomGray} color="gray" />
                    <ProgressBar value={randomBlack} color="black" />
                    <ProgressBar value={randomWhite} color="white" />
                </>
            ),
            code: `<ProgressBar value="${randomPrimary}" color="primary" />\n<ProgressBar value="${randomSecondary}" color="secondary" />\n<ProgressBar value="${randomSuccess}" color="success" />\n<ProgressBar value="${randomDanger}" color="danger" />\n<ProgressBar value="${randomWarning}" color="warning" />\n<ProgressBar value="${randomGray}" color="gray" />\n<ProgressBar value="${randomBlack}" color="black" />\n<ProgressBar value="${randomWhite}" color="white" />`,
        },
    ]

    const propsItems = [
        {
            name: "value",
            type: "Number (0 to 100)",
            example: "42",
            required: "Yes",
        },
        {
            name: "color",
            type: "String",
            example: "success",
            possible: commonProps.colorsShort,
            default: "primary",
        },
        {
            name: "animated",
            type: "Boolean",
            default: "true",
        },
    ]

    return <ComponentPage items={items} propsItems={propsItems} />
}

export default ProgressBarPage
